import { ref } from "vue";
import { DateTime } from "luxon";
import eventBus from "../Helpers/eventBus";
import axios from "axios";

// vajadzīgs, jo doubleclikc ātri uz sadaļas un prom, neaptur tickeri.
// Turpina pildīties callbacki un beigās startē ticker.
// Bet ja pirms tam jau aiznavigējām prom,
// tad nevajag startēt tomēr tickeri. Tpāēc šie vars ieviesti:
let abortController = null;
let wholeSecondTimeoutId = null;

let isLocalDebug = false;
if (import.meta.env.VITE_APP_ENV === "local") {
    isLocalDebug = true;
    console.log("localEventTimeTicker.isLocalDebug", isLocalDebug);
}

let tz = null;

export const device_ts_ms_offset = ref(0);

const debugLocaleStringFormat = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
    timeZoneName: "short",
    fractionalSecondDigits: 3,
};

/**
 * Self-adjusting interval to account for drifting
 *
 * @param {function} workFunc  Callback containing the work to be done
 *                             for each interval
 * @param {int}      interval  Interval speed (in milliseconds)
 * @param {function} errorFunc (Optional) Callback to run if the drift
 *                             exceeds interval
 */
function AdjustingInterval(workFunc, interval, errorFunc) {
    // You can also change the interval while it's in progress
    // ticker.interval = 99;

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    this.expected = null;
    let timeout;
    this.interval = interval;
    this.lastSyncAt = null;

    this.start = function () {
        // do not run in SSR
        if (typeof window !== "undefined") {
            if (!this.lastSyncAt) {
                this.lastSyncAt = Date.now();
            }
            that.expected = Date.now() + this.interval;
            // console.log("START that.expected", that.expected);
            timeout = setTimeout(step, this.interval);
        }
    };

    this.isRunning = function () {
        return timeout > 0;
    };

    this.stop = function () {
        clearTimeout(timeout);
    };

    function step() {
        // console.log("STEP that.expected", that.expected);
        const drift = Date.now() - that.expected;
        if (drift > that.interval) {
            // You could have some default stuff here too...
            // console.log("errorFunc");
            if (errorFunc) errorFunc();
        }

        // console.log("Date.now() - that.lastSyncAt.getTime()", Date.now() - that.lastSyncAt);
        if (Date.now() - that.lastSyncAt > 1000 * 60 * 30) {
            // every 30mins try to resync
            tryToResync();
        }
        workFunc();
        // console.log("STEP that.expected", that.expected);
        that.expected += that.interval;

        // console.log("that.interval - drift", that.interval - drift);
        timeout = setTimeout(step, Math.max(0, that.interval - drift));
    }
}

const doWork = function () {
    if (device_ts_ms_offset.value !== null && isLocalDebug) {
        console.log(
            DateTime.now().minus(device_ts_ms_offset.value).setZone(tz).toLocaleString(debugLocaleStringFormat),
        );
    }

    eventBus.$emit("updateTimeForTheLocalEventTimeComponent", {
        device_ts_ms_offset: device_ts_ms_offset.value,
        timezone: tz,
    });
};

const doError = function () {
    // console.warn("The drift exceeded the interval.");
};

// (The third argument is optional)
const ticker = new AdjustingInterval(doWork, 1000, doError);

function calcAverageOffset(numbers, avgByKey) {
    numbers.sort((a, b) => a.RTT - b.RTT);
    // console.log(numbers);
    numbers = numbers.splice(0, 3);
    // console.log(numbers);

    // Return the average of the best candidates
    let sum = 0;
    numbers.forEach(function (value) {
        sum += value[avgByKey];
    });

    return Math.round(sum / numbers.length);
}

function getDeviceTsMsOffsetAndStartTicker(maxTimes = 3) {
    const offsets = [];
    let counter = 0;

    const privateCalculateDeviceTsMsOffset = function () {
        // https://en.wikipedia.org/wiki/Cristian%27s_algorithm
        const t0 = Date.now();

        // eslint-disable-next-line no-undef
        const url = route("api.tsms") + `?t=${t0}`;
        // url = "https://roadbookrally.com/api/v2/tsms?t=" + t0;
        axios.get(url, { signal: abortController.signal }).then((response) => {
            counter++;

            const t = response.data.tsms;
            const t1 = new Date().getTime();
            const RTT = t1 - t0;
            const tmpOffset = RTT / 2;
            const syncedTime = t + tmpOffset;
            const deviceOffset = t1 - syncedTime;
            // console.log('synced time:', new Date(syncedTime).toLocaleString());

            offsets.push({
                RTT: RTT,
                deviceOffset: deviceOffset,
            });
            // console.log(JSON.stringify(offsets));

            if (counter < maxTimes) {
                // Repeat
                privateCalculateDeviceTsMsOffset();
            } else {
                const avgOffset = calcAverageOffset([...offsets], "deviceOffset");
                const avgRTT = calcAverageOffset([...offsets], "RTT");

                device_ts_ms_offset.value = avgOffset;

                // if (Math.random() > 0.5) {
                //     console.info("TESTING WRONG");
                //     device_ts_ms_offset.value = 1000 * 10 * 60 - 500;
                // }

                if (isLocalDebug) {
                    console.log("localEventTimeTicker.device_ts_ms_offset =", device_ts_ms_offset.value);
                    console.log("localEventTimeTicker.device_RTT =", avgRTT);
                }

                const syncedDate = new Date(new Date().getTime() - device_ts_ms_offset.value);

                if (isLocalDebug) {
                    console.log(
                        "localEventTimeTicker synced time =",
                        syncedDate.toLocaleString("en-GB", debugLocaleStringFormat),
                    );
                }

                const msUntilFullSecond = 1000 - syncedDate.getMilliseconds();

                if (isLocalDebug) {
                    console.log("localEventTimeTicker.msUntilFullSecond = ", msUntilFullSecond);
                }
                wholeSecondTimeoutId = setTimeout(() => {
                    ticker.start();
                }, msUntilFullSecond);
            }
        });
    };

    privateCalculateDeviceTsMsOffset();
}

function tryToResync() {
    if (navigator && navigator.onLine) {
        ticker.lastSyncAt = Date.now();

        abortController = new AbortController();

        const maxTimes = 3;

        const offsets = [];
        let counter = 0;

        const resync = function () {
            // https://en.wikipedia.org/wiki/Cristian%27s_algorithm
            const t0 = Date.now();

            // eslint-disable-next-line no-undef
            const url = route("api.tsms") + `?t=${t0}`;
            // url = "https://roadbookrally.com/api/v2/tsms?t=" + t0;
            axios.get(url, { signal: abortController.signal }).then((response) => {
                counter++;

                const t = response.data.tsms;
                const t1 = new Date().getTime();
                const RTT = t1 - t0;
                const tmpOffset = RTT / 2;
                const syncedTime = t + tmpOffset;
                const deviceOffset = t1 - syncedTime;
                // console.log('synced time:', new Date(syncedTime).toLocaleString());

                offsets.push({
                    RTT: RTT,
                    deviceOffset: deviceOffset,
                });
                // console.log(JSON.stringify(offsets));

                if (counter < maxTimes) {
                    // Repeat
                    resync();
                } else {
                    const avgOffset = calcAverageOffset([...offsets], "deviceOffset");
                    const avgRTT = calcAverageOffset([...offsets], "RTT");

                    if (isLocalDebug) {
                        console.log(
                            "device time before recync",
                            new Date(new Date().getTime() - device_ts_ms_offset.value).toLocaleString(
                                "en-GB",
                                debugLocaleStringFormat,
                            ),
                        );
                    }

                    device_ts_ms_offset.value = avgOffset;

                    if (isLocalDebug) {
                        console.log("localEventTimeTicker.device_ts_ms_offset =", device_ts_ms_offset.value);
                        console.log("localEventTimeTicker.device_RTT =", avgRTT);
                    }

                    const syncedDate = new Date(new Date().getTime() - device_ts_ms_offset.value);

                    if (isLocalDebug) {
                        console.log(
                            "localEventTimeTicker synced time =",
                            syncedDate.toLocaleString("en-GB", debugLocaleStringFormat),
                        );
                    }

                    const msUntilFullSecond = 1000 - syncedDate.getMilliseconds();

                    if (isLocalDebug) {
                        console.log("localEventTimeTicker.msUntilFullSecond = ", msUntilFullSecond);
                        console.log("resync before this.expected", ticker.expected);
                        console.log("(1000 - msUntilFullSecond)", 1000 - msUntilFullSecond);
                    }

                    ticker.expected = Date.now() - (1000 - msUntilFullSecond);

                    if (isLocalDebug) {
                        console.log("resync after this.expected", ticker.expected);
                    }
                }
            });
        };

        resync();
    } else {
        console.log("offline");
    }
}

export function startLocalEventTimeTicker(timezone) {
    if (typeof window === "undefined") {
        // do not run local event time ticker in SSR
        return;
    }

    tz = timezone;

    abortController = new AbortController();

    if (isLocalDebug) {
        if (ticker.isRunning()) {
            console.info("ticker is running!!!!!!");
        }
        console.log("startLocalEventTimeTicker");
        console.log("localEventTimeTicker.tz =", tz);
        console.log(
            DateTime.now().setZone(tz).toLocaleString({
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            }),
            "= time in " + tz + " (localEventTimeTicker)",
        );
    }

    getDeviceTsMsOffsetAndStartTicker();
}

export function stopLocalEventTimeTicker() {
    if (typeof window === "undefined") {
        // do not run local event time ticker in SSR
        return;
    }

    if (isLocalDebug) {
        console.log("stopLocalEventTimeTicker");
    }
    // cancel the request
    if (abortController) {
        abortController.abort();
    }
    if (wholeSecondTimeoutId) {
        // console.log("wholeSecondTimeoutId", wholeSecondTimeoutId);
        clearTimeout(wholeSecondTimeoutId);
    }
    ticker.stop();
}
